export default {
  setActiveConversation(state, conversation) {
    state.activeConversation = conversation;
  },
  setUserConversations(state, conversations) {
    state.conversations = conversations;
  },
  addToUserConversations(state, conversation) {
    state.conversations = [...state.conversations, conversation];
  },
  updateLastMessage(state, { id, lastMessage }) {
    state.conversations = state.conversations.map(c => (c.id === id ? { ...c, lastMessage } : c));
  },
  setMessages(state, messages) {
    state.activeConversation.messages = [...state.activeConversation.messages, ...messages];
  },
  addToMessages(state, message) {
    state.activeConversation.messages = [...state.activeConversation.messages, message];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/chat/mutations.js